import axiosConfig from "./axiosConfig";

interface MultisiteSpvPayload {
  siteIds: string[];
  [key: string]: any;
}

const postPreviewMultisiteSpv = async (
  authToken: string,
  payload: MultisiteSpvPayload
): Promise<any> => {
  const { data } = await axiosConfig.post(
    `/site/preview/multisite_spv`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postPreviewMultisiteSpv;
